import { render, staticRenderFns } from "./MgmCampaignList.vue?vue&type=template&id=7e878472&scoped=true&"
import script from "./MgmCampaignList.vue?vue&type=script&lang=js&"
export * from "./MgmCampaignList.vue?vue&type=script&lang=js&"
import style0 from "./MgmCampaignList.vue?vue&type=style&index=0&id=7e878472&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e878472",
  null
  
)

export default component.exports